module.exports = __webpack_public_path__ + "img/share-poster-right-text.e1ebb671.png";